// Chart Types => [
// 1 => 'bit',
// 2 => 'numeric'
// ]
export default [
  {
    type: 1,
    charts: ["خروجی"],
    charts_type: [1],
    chart_num: 6,
    chart_index: [[1, 6]],
  },
  {
    type: 2,
    charts: ["خروجی", "ورودی", "سناریو"],
    charts_type: [1, 1, 1],
    chart_num: 28,
    chart_index: [
      [1, 12],
      [13, 24],
      [25, 28],
    ],
  },
  {
    type: 7,
    charts: ["خروجی", "ورودی", "سناریو"],
    charts_type: [1, 1, 1],
    chart_num: 28,
    chart_index: [
      [1, 12],
      [13, 24],
      [25, 28],
    ],
  },
  {
    type: 8,
    charts: ["خروجی", "ورودی", "سناریو"],
    charts_type: [1, 1, 1],
    chart_num: 28,
    chart_index: [
      [1, 12],
      [13, 24],
      [25, 28],
    ],
  },
  {
    type: 10,
    charts: ["خروجی", "ورودی", "سناریو"],
    charts_type: [1, 1, 1],
    chart_num: 28,
    chart_index: [
      [1, 12],
      [13, 24],
      [25, 28],
    ],
  },
  {
    type: 11,
    charts: ["خروجی"],
    charts_type: [1],
    chart_num: 1,
    chart_index: [[1, 1]],
  },
  {
    type: 12,
    charts: ["خروجی", "ورودی", "سناریو"],
    charts_type: [1, 1, 1],
    chart_num: 28,
    chart_index: [
      [1, 12],
      [13, 24],
      [25, 28],
    ],
  },
  {
    type: 13,
    charts: ["خروجی"],
    charts_type: [1, 1, 1],
    chart_num: 2,
    chart_index: [[1, 2]],
  },
  {
    type: 14,
    charts: ["خروجی"],
    charts_type: [1, 1, 1],
    chart_num: 3,
    chart_index: [[1, 3]],
  },
  {
    type: 15,
    charts: ["خروجی"],
    charts_type: [1, 1, 1],
    chart_num: 4,
    chart_index: [[1, 4]],
  },
  {
    type: 4,
    charts: ["درصد دیمر", "سناریو"],
    charts_type: [2, 1],
    chart_num: 10,
    chart_index: [
      [1, 6],
      [7, 10],
    ],
  },
  {
    type: 9,
    charts: ["درصد دیمر", "سناریو"],
    charts_type: [2, 1],
    chart_num: 10,
    chart_index: [
      [1, 6],
      [7, 10],
    ],
  },
  {
    type: 5,
    charts: ["دما", "رطوبت", "خروجی", "سناریو"],
    charts_type: [2, 2, 1, 1],
    chart_num: 16,
    chart_index: [
      [1, 5],
      [6, 6],
      [7, 12],
      [13, 16],
    ],
  },
  {
    type: 3,
    charts: ["سناریو"],
    charts_type: [1],
    chart_num: 20,
    chart_index: [[1, 20]],
  },
];
